import {Action} from "redux";
import {IAuthActionCreator} from "../action/auth_action";
import {
    CreateCustomerRequest,
    LoginRequest,
    PasswordResetRequest,
    ApplyClientRequest, OnAuthListenerRequest, OffAuthListenerRequest
} from "../request/auth_request";

interface IAuthDispatcher {
    onAuthListener(item: OnAuthListenerRequest): void;
    offAuthListener(item: OffAuthListenerRequest): void;
    login(item: LoginRequest): void;
    logout(): void;
    resetPassword(item: PasswordResetRequest): void;
    createCustomer(item: CreateCustomerRequest): void;
    applyClient(item: ApplyClientRequest): void;
    getMe(): void;
}

class Dispatcher implements IAuthDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IAuthActionCreator) {

    }

    public onAuthListener(item: OnAuthListenerRequest): void {
        this.dispatch(this.actionCreator.requestOnAuthListenerAction(item))
    }

    public offAuthListener(item: OffAuthListenerRequest): void {
        this.dispatch((this.actionCreator.requestOffAuthListenerAction(item)))
    }

    public login = (item: LoginRequest): void => {
        this.dispatch(this.actionCreator.requestLoginAction(item));
    };

    public logout = (): void => {
        this.dispatch(this.actionCreator.requestLogoutAction());
    };

    public resetPassword = (item: PasswordResetRequest): void => {
        this.dispatch(this.actionCreator.requestPasswordResetAction(item));
    };

    public createCustomer = (item: CreateCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestCreateCustomerAction(item));
    };

    public applyClient = (item: ApplyClientRequest): void => {
        this.dispatch(this.actionCreator.requestApplyClientAction(item));
    };

    public getMe = (): void => {
        this.dispatch(this.actionCreator.requestGetMeAction());
    };

}

const createAuthDispatcher = (dispatch: (action: Action) => void, actionCreator: IAuthActionCreator): IAuthDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IAuthDispatcher, createAuthDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/auth_dispatcher.ts